exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".EnableCustomersModal_dialog_header{font-size:18px}.EnableCustomersModal_dialog_content{padding:10px 24px}.EnableCustomersModal_button{font-size:14px;cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"dialog_header": "EnableCustomersModal_dialog_header",
	"dialog_content": "EnableCustomersModal_dialog_content",
	"button": "EnableCustomersModal_button"
};